import { ShieldCheck } from 'lucide-react';
import { Reveal } from '../Reveal';
import { CheckList } from '../compass/shared';

// Section 7 — compliance and training visibility. Honest scope: record
// management and visibility, not a guarantee of compliance or an LMS.
export const PulseCompliance = ({ sp }) => (
  <section aria-labelledby="pulse-compliance-heading" data-testid="pulse-compliance" className="relative overflow-hidden bg-navy-900 py-20 sm:py-28">
    <div className="grain-overlay" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold-500">Workforce Compliance</p>
        <h2 id="pulse-compliance-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="pulse-compliance-heading">
          See what is valid, expiring or missing
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">{sp.complianceCopy}</p>
        <p className="mt-6 border-l-2 border-gold-500 pl-4 text-sm font-medium leading-relaxed text-slate-300">
          Pulse supports record management and visibility — it does not by itself guarantee compliance or replace HR advice.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="rounded-xl border border-white/10 bg-white/5 p-7 sm:p-8">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold-500 text-navy-950">
            <ShieldCheck className="h-5 w-5" aria-hidden="true" />
          </span>
          <div className="mt-6">
            <CheckList items={sp.compliancePoints || []} dark testid="pulse-compliance-points" />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
